// src/App.tsx
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { OrganizerProvider } from "./contexts/OrganizerContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import Layout from "./components/Layout/Layout";
import PrivateRoute from "./components/PrivateRoute";
import ScrollToTop from "./components/ScrollToTop";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Pages
import HomePage from "./pages/HomePage";
import EventListPage from "./pages/EventListPage";
import EventDetailPage from "./pages/EventDetailPage";
import CheckoutPage from "./pages/CheckoutPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import MyPage from "./pages/MyPage";
import OrganizerPage from "./pages/OrganizerPage";
import OrganizerRegisterPage from "./pages/OrganizerRegisterPage";
import OrganizerLandingPage from "./pages/OrganizerLandingPage";
import OrganizerProfilePage from "./pages/OrganizerProfilePage";
import TermsForOrganizersPage from "./pages/TermsForOrganizersPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import HelpPage from "./pages/HelpPage";
import CommercialTransactionPage from "./pages/CommercialTransactionPage";
import CancellationPolicyPage from "./pages/CancellationPolicyPage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import NotFoundPage from "./pages/NotFoundPage";

function App() {
	return (
		<div className="min-h-screen bg-gray-50 dark:bg-gray-900">
			<BrowserRouter
				future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
			>
				<ScrollToTop />
				<ThemeProvider>
					<AuthProvider>
						<OrganizerProvider>
							<Routes>
								{/* Routes with Layout (Header) */}
								<Route path="/" element={<Layout />}>
									<Route index element={<HomePage />} />
									<Route path="events" element={<EventListPage />} />
									<Route path="events/:id" element={<EventDetailPage />} />
									<Route
										path="organizers/:id"
										element={<OrganizerProfilePage />}
									/>
									<Route
										path="organizer/start"
										element={<OrganizerLandingPage />}
									/>
									<Route
										path="terms-for-organizers"
										element={<TermsForOrganizersPage />}
									/>
									<Route
										path="terms-of-service"
										element={<TermsOfServicePage />}
									/>
									<Route
										path="privacy-policy"
										element={<PrivacyPolicyPage />}
									/>
									<Route path="help" element={<HelpPage />} />
								<Route
									path="commercial-transaction"
									element={<CommercialTransactionPage />}
								/>
								<Route
									path="cancellation-policy"
									element={<CancellationPolicyPage />}
								/>
								<Route
									path="cookie-policy"
									element={<CookiePolicyPage />}
								/>
									<Route
										path="checkout/:eventExternalId"
										element={
											<PrivateRoute>
												<CheckoutPage />
											</PrivateRoute>
										}
									/>
									<Route
										path="payment-success"
										element={
											<PrivateRoute>
												<PaymentSuccessPage />
											</PrivateRoute>
										}
									/>
									<Route path="*" element={<NotFoundPage />} />
								</Route>

								{/* Routes without Layout (No Header) */}
								<Route
									path="mypage/*"
									element={
										<PrivateRoute>
											<MyPage />
										</PrivateRoute>
									}
								/>
								<Route
									path="organizer/register"
									element={<OrganizerRegisterPage />}
								/>
								<Route
									path="organizer/*"
									element={
										<PrivateRoute>
											<OrganizerPage />
										</PrivateRoute>
									}
								/>
							</Routes>
							{/* React Toastify Container */}
							<ToastContainer
								position="bottom-right"
								autoClose={5000}
								hideProgressBar={false}
								newestOnTop={false}
								closeOnClick
								rtl={false}
								pauseOnFocusLoss
								draggable
								pauseOnHover
							/>
						</OrganizerProvider>
						</AuthProvider>
					</ThemeProvider>
			</BrowserRouter>
		</div>
	);
}

export default App;
